import { useState, useEffect, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import { Toaster } from "./components/ui/sonner";
import { Loader2 } from "lucide-react";

// Lazy load components for better performance
const Dashboard = lazy(() => import("./pages/Dashboard"));
const NuevoExpediente = lazy(() => import("./pages/NuevoExpediente"));
const DetalleExpediente = lazy(() => import("./pages/DetalleExpediente"));

// Loading component
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center">
    <Loader2 className="w-8 h-8 animate-spin text-cyan-600" />
  </div>
);

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }, [token]);

  const ProtectedRoute = ({ children }) => {
    if (!token) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/login" element={<Login setToken={setToken} />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard token={token} setToken={setToken} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/nuevo"
              element={
                <ProtectedRoute>
                  <NuevoExpediente token={token} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expediente/:id"
              element={
                <ProtectedRoute>
                  <DetalleExpediente token={token} />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;